import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import HomeImage from '../../../../assets/images/content/homepage_image.png';
import Button from '../../../incase-domain/components/button/Button';

const NOBULA_EU_CASE_CREATOR_URL = 'https://www.nobula.eu/';

function Homepage(): JSX.Element {
    const {t} = useTranslation();

    return (
        <div className="p-homepage">
            <div className="p-homepage__container">
                <div className="p-homepage__intro">
                    <div className="p-homepage__intro_content">
                        <h1 className="p-homepage__intro_header">{t('homepage.header')}</h1>
                        <p className="p-homepage__intro_description">{t('homepage.description')}</p>
                    </div>
                    <div className="p-homepage__buttons">
                        <Button
                            variant="solid"
                            color="info"
                            size="xl"
                            wide
                            onClick={() => window.open(NOBULA_EU_CASE_CREATOR_URL, '_blank', 'noopener,noreferrer')}
                        >
                            {t('homepage.findOutMore')}
                        </Button>
                        <Button
                            variant="soft"
                            color="primary"
                            size="xl"
                            wide
                            onClick={() => {
                                window.location.href = 'mailto:ncc@nobula.eu';
                            }}
                        >
                            {t('homepage.contactUs')}
                        </Button>
                    </div>
                </div>

                <div className="p-homepage__upload">
                    <img src={HomeImage} alt="Home hero img" />
                </div>
            </div>

            <div className="p-homepage__powered">
                <Button variant="ghost" size="xl" onClick={() => window.open(NOBULA_EU_CASE_CREATOR_URL, '_blank', 'noopener,noreferrer')}>
                    <Trans i18nKey="homepage.poweredBy" />
                    &nbsp;<strong>Nobula.eu</strong>
                </Button>
            </div>
        </div>
    );
}

export default Homepage;
